// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#widgets-sidebar {
  overflow-y: auto;
  overflow-x: hidden;
}
#widgets-sidebar #group-title {
  background-color: #ff9e01;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 10px;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
#widgets-sidebar #group-title #icon {
  font-size: 16px;
  line-height: 40px;
}
#widgets-sidebar #group-title #title {
  display: flex;
  align-items: center;
}
#clipboard-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
}
#clipboard-list-item #title-container {
  display: flex;
  flex-direction: column;
  flex: 1;
}
#clipboard-list-item #title-container #secondary {
  font-size: 14px;
  line-height: 16px;
  height: 16px;
  margin: 4px 0px 0px;
  color: rgba(0, 0, 0, 0.54);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
